import { __spreadArrays } from "tslib";
export function defaultLogSink(widgetTagName, logLevel, message) {
    var _a;
    var optionalParams = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        optionalParams[_i - 3] = arguments[_i];
    }
    if (console[logLevel] !== undefined) {
        (_a = console[logLevel]).call.apply(_a, __spreadArrays([console,
            widgetTagName,
            logLevel,
            message], optionalParams));
    }
    else {
        console.log.apply(console, __spreadArrays([widgetTagName, logLevel, message], optionalParams));
    }
}
